import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indoor-teams-bootstrap',
  templateUrl: './indoor-teams-bootstrap.component.html',
  styleUrls: ['./indoor-teams-bootstrap.component.scss']
})
export class IndoorTeamsBootstrapComponent {
  constructor() {}
}
